import PropTypes from "prop-types";

export const propTypes = {
  taskId: PropTypes.number,
  projectId: PropTypes.number,
};
